/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { AxiosRequestConfig } from 'axios';
import { api, extractResponse } from '@utils/network';
import { LinkedAccountResponse } from './types';

export const Request = {
  list: (config?: AxiosRequestConfig): Promise<LinkedAccountResponse> =>
    extractResponse<LinkedAccountResponse>(api.get(`/account/linkedAccounts`, config))
};
